import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderPageData } from '../../../api';
import { TrialCard } from './TrialCard';

type TrialsSectionProps = {
  orderPages: OrderPageData[];
};

export const TrialsSection = ({ orderPages }: TrialsSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (!orderPages.length) {
    return null;
  }

  return (
    <Grid container flexDirection="column" mt={isSmallScreen ? 4 : 8} mb={isSmallScreen ? 6 : 10}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          marginBottom: isSmallScreen ? 2 : 3,
          textAlign: isSmallScreen ? 'center' : 'start',
        }}>
        {t('storefront.ourTrials')}
      </Typography>
      <Grid
        container
        flexDirection="column"
        sx={{
          gap: 1.5,
          width: isSmallScreen ? '100%' : '50%',
        }}>
        {orderPages.map((orderPage) => (
          <TrialCard key={orderPage.id} orderPage={orderPage} />
        ))}
      </Grid>
    </Grid>
  );
};
